import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionPut, serviceCall } from '../../serviceCall'

const apiUpdateCompany = (data, callback, errorCallBack, params) => {

    return async (dispatch) => {

        formDataCommonFunctionPut(data, apiConstants.COMPANIES.UPDATE_COMPANY)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}

export default apiUpdateCompany;